import { styled as muiStyled } from '@mui/material'

export const FourStepRecoveryPlanLevelContainer = muiStyled('div')(
  ({ theme }) => `  
    .icon-heading {
        font-size: 1em;
        font-weight: 600;
    }
`,
)

export const FourStepRecoveryPlanLevelItem = muiStyled('div')(
  ({ theme }) => `
  background: #000;
  aspect-ratio: 1;
  justify-content: center;
  display: flex;
  align-items: center;
  color: white;
  width: 90%;
  margin: 0 auto;
  border-radius: 50px;
`,
)

export const FourStepRecoveryPlanContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  padding: 24px 24px 48px 24px;
  justify-content: center;
  gap: 50px;
  background: #1c2120;

  @media (min-width: 768px) {
    height: 900px;
  }  
  @media (min-width: 996px){
    height: 800px;
  }
`,
)
